module.exports = __webpack_public_path__ + "static/media/screenshot(54).bf18516f.jpg";